import React from 'react'

export default function Confirmed ({ fontsize = '' }: { fontsize?: string | undefined }): JSX.Element {
    // m-0 p-2
    return <div className={`badge badge-light-success   border border-success ${fontsize}`}>Confirmed</div>
}
